export default "__VITE_ASSET__BXwaYEnu__"